/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:23
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').
    controller('PrDataCtrl', ["$rootScope", "$scope", "$dialog", "PhysicalResource", "PhysicalResourceView", "PhysicalResourceData",
    "$timeout", function($rootScope,$scope,$dialog,PhysicalResource,PhysicalResourceView,PhysicalResourceData, $timeout)
{
    $scope.displayModificationMessage = false;
    $scope.displayError = false;
    $scope.prIsLoading = false;


    $scope.openDeletedPrViewConfirmDialog  = function() {
        if ($scope.dd.edited.prView) {
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl:  '/partials/global/removeConfirm.html',
                controller: 'DialogCtrl' ,
                resolve: {
                    dialogsModel: function() {
                        var tableModel = [] ;
                        tableModel["label"] = $scope.dd.edited.prView.label;
                        return tableModel;
                    }}};

            var d = $dialog.dialog(opts);
            d.open().then(function(result){
                if (result)
                    $scope.removeEditedPrView();
            });
        }
    };
    $scope.setEditedPrView   = function(prView)
    {
        if ($scope.dd.edited.prView && $scope.dd.edited.prView.isChanged())
        {
            $scope.displayChangeMsg = true;
            return;
        }

        $scope.dd.edited.prView = prView;
    };
    $scope.createPhysicalResource  = function()
    {
        if ($scope.dd.edited.prView && $scope.dd.edited.prView.isChanged())
        {
            $scope.displayChangeMsg = true;
            return;
        }
        var newPrView =   new PhysicalResourceView(null,-1,$scope,$scope.dd.view.physicalResourcesActiveView.length);
        $scope.dd.view.physicalResourcesActiveView.push(newPrView);
        $scope.dd.view.physicalResourcesView.push(newPrView);
        $scope.dd.edited.prView = newPrView;
    };
    $scope.cancelEditedPrView   = function()
    {
        if ($scope.dd.edited.prView.prIndex!=-1)// retrieve old value from server
        {
            $scope.dd.edited.prView.reloadModel();
        }
        else
        {
            var index = $scope.dd.view.physicalResourcesView.indexOf($scope.dd.edited.prView);
            if (index>=0)
                $scope.dd.view.physicalResourcesView.splice(index,1);
            index = $scope.dd.view.physicalResourcesActiveView.indexOf($scope.dd.edited.prView);
            if (index>=0)
                $scope.dd.view.physicalResourcesActiveView.splice(index,1);
        }
        $scope.dd.edited.prView = null;
        $scope.displayError = false;
        $scope.displayChangeMsg = false;
    };

    $scope.saveEditedPrView = function () {
        if ($scope.dd.edited.prView) {
            $scope.prIsLoading = true;
            let promises = [];
            for (let i = 0; i < $scope.dd.view.physicalResourcesActiveView.length; i++) {
                promises.push($scope.dd.view.physicalResourcesActiveView[i].updateModelWithPromise());
            }

            Promise.all(promises).finally(() => {
                $timeout(() => {
                    $scope.prIsLoading = false;
                });
            });

            $scope.sortPrActiveViewArray();
        }
        $scope.dd.edited.prView = null;
        $scope.displayError = false;
        $scope.displayChangeMsg = false;
    };

    $scope.removeEditedPrView  = function()
    {

        if ($scope.dd.edited.prView)
        {
            if ($scope.dd.edited.prView.prIndex!=-1)// retrieve old value from server
                $scope.dd.edited.prView.removeModel();
            var index = $scope.dd.view.physicalResourcesActiveView.indexOf($scope.dd.edited.prView);
            if (index!=-1)
            {
                $scope.dd.view.physicalResourcesActiveView.splice(index,1);
                if ($scope.dd.view.physicalResourcesDeletedView)
                    $scope.dd.view.physicalResourcesDeletedView.push($scope.dd.edited.prView)
                index = $scope.dd.view.physicalResourcesView.indexOf($scope.dd.edited.prView);
                if (index!=-1)
                    $scope.dd.view.physicalResourcesView.splice(index,1);

                var indexStartDelete = index;
                for(var i=indexStartDelete; i<$scope.dd.view.physicalResourcesActiveView.length; i++) {
                    $scope.dd.view.physicalResourcesActiveView[i].order--;
                    $scope.dd.view.physicalResourcesActiveView[i].updateModel();
                }
            }
            $scope.dd.edited.prView = null;
            $scope.displayError = false;
            $scope.displayChangeMsg = false;
        }


    };
}]);




// WEBPACK FOOTER //
// ./js/controllers/pro/configuration/pr/prDataCtrl.js